export default __webpack_public_path__ + "static/media/Libreria.eec5f409.png";